import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";

export interface RichTextFullWidthProps {
  content: any;
  contentTinyMce?: any;
  addBorder: boolean;
  capitaliseFirstLetter?: boolean;
  hideFromScreenReaders?: boolean;
}

const RichTextFullWidth = (props: RichTextFullWidthProps) => {
  const { content, addBorder, capitaliseFirstLetter, contentTinyMce } = props;
  return (
    <div className="wrapper">
      <RichTextDisplay
        hideFromScreenReaders={props.hideFromScreenReaders}
        richText={content}
        tinyMceRichText={contentTinyMce}
        capitaliseFirstLetter={capitaliseFirstLetter}
        addBorder={addBorder}
        richTextStyles
      />
    </div>
  );
};

export default RichTextFullWidth;
